import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState, useEffect, useMemo } from 'react';
import { useCookies } from '@magalu/mixer-utils';
import useShortenLink from '../../../../hooks/useShortenLink';
import { SessionStorageItem, ShortenLinkTypes } from '../constants';
import { getShareableLinks } from '../utils';
var isUrlInvalid = function isUrlInvalid(_ref) {
  var url = _ref.url,
    productId = _ref.productId,
    sku = _ref.sku;
  return !url || url === 'null' || url === 'undefined' || sku !== productId;
};
var shouldSkipShortenLink = function shouldSkipShortenLink(storageKey, toggleRemovePromoterOfferTabs) {
  return storageKey === SessionStorageItem.MAGALY && toggleRemovePromoterOfferTabs === true;
};
var getOnelinkConfig = function getOnelinkConfig(toggleSharePromoterOfferLink, linksToShare) {
  return toggleSharePromoterOfferLink === 'magaly' ? {
    params: {
      link: linksToShare == null ? void 0 : linksToShare.desktopLink
    },
    type: ShortenLinkTypes.MAGALY
  } : {
    params: {
      addPartnerId: true,
      desktopLink: linksToShare == null ? void 0 : linksToShare.desktopLink,
      link: linksToShare == null ? void 0 : linksToShare.link
    },
    type: ShortenLinkTypes.ONELINK
  };
};
var useProductShortenLink = function useProductShortenLink(_ref2) {
  var active = _ref2.active,
    data = _ref2.data,
    structure = _ref2.structure;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    oneLinkUrlToCopy = _useState2[0],
    setOneLinkUrlToCopy = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    magalyUrlToCopy = _useState4[0],
    setMagalyUrlToCopy = _useState4[1];
  var _useCookies = useCookies(),
    _useCookies$toggleSha = _useCookies.toggleSharePromoterOfferLink,
    toggleSharePromoterOfferLink = _useCookies$toggleSha === void 0 ? '' : _useCookies$toggleSha,
    _useCookies$toggleRem = _useCookies.toggleRemovePromoterOfferTabs,
    toggleRemovePromoterOfferTabs = _useCookies$toggleRem === void 0 ? '' : _useCookies$toggleRem;
  var _ref3 = structure || {},
    _ref3$route = _ref3.route,
    route = _ref3$route === void 0 ? {} : _ref3$route;
  var linksToShare = useMemo(function () {
    return getShareableLinks({
      data: data,
      structure: structure,
      toggleSharePromoterOfferLink: toggleSharePromoterOfferLink
    });
  }, [data, structure, toggleSharePromoterOfferLink]);
  var magalyShortenLink = useShortenLink(ShortenLinkTypes.MAGALY, {
    link: linksToShare == null ? void 0 : linksToShare.magaly
  });
  var onelinkConfig = getOnelinkConfig(toggleSharePromoterOfferLink, linksToShare);
  var onelinkShortenLink = useShortenLink(onelinkConfig.type, onelinkConfig.params);
  var shortenedConfigs = useMemo(function () {
    return {
      magaly: magalyShortenLink,
      onelink: onelinkShortenLink
    };
  }, [magalyShortenLink, onelinkShortenLink]);
  var updateShortenedLink = function updateShortenedLink(_ref4) {
    var storageKey = _ref4.storageKey,
      setUrlToCopy = _ref4.setUrlToCopy,
      config = _ref4.config;
    var url = sessionStorage.getItem(storageKey);
    var sku = sessionStorage.getItem('sku');
    if (!isUrlInvalid({
      productId: route == null ? void 0 : route.productId,
      sku: sku,
      url: url
    })) {
      setUrlToCopy(url);
      return;
    }
    setUrlToCopy('');
    if (!shouldSkipShortenLink(storageKey, toggleRemovePromoterOfferTabs)) {
      config.handleShortenLink();
    }
  };
  var updateSessionStorage = function updateSessionStorage(_ref5) {
    var sessionStorageKey = _ref5.sessionStorageKey,
      link = _ref5.link,
      setUrlToCopy = _ref5.setUrlToCopy;
    sessionStorage.setItem(sessionStorageKey, link);
    sessionStorage.setItem('sku', route.productId);
    setUrlToCopy(link);
  };
  useEffect(function () {
    if (!active) return;
    updateShortenedLink({
      config: shortenedConfigs.onelink,
      setUrlToCopy: setOneLinkUrlToCopy,
      storageKey: SessionStorageItem.ONELINK
    });
    updateShortenedLink({
      config: shortenedConfigs.magaly,
      setUrlToCopy: setMagalyUrlToCopy,
      storageKey: SessionStorageItem.MAGALY
    });
  }, [structure, active]);
  useEffect(function () {
    if (shortenedConfigs.magaly.shortLink) {
      updateSessionStorage({
        link: shortenedConfigs.magaly.shortLink,
        sessionStorageKey: SessionStorageItem.MAGALY,
        setUrlToCopy: setMagalyUrlToCopy
      });
    }
    if (shortenedConfigs.onelink.shortLink) {
      updateSessionStorage({
        link: shortenedConfigs.onelink.shortLink,
        sessionStorageKey: SessionStorageItem.ONELINK,
        setUrlToCopy: setOneLinkUrlToCopy
      });
    }
  }, [shortenedConfigs.magaly.shortLink, shortenedConfigs.onelink.shortLink]);
  useEffect(function () {
    if (shortenedConfigs.magaly.isLoading) setMagalyUrlToCopy('');
    if (shortenedConfigs.onelink.isLoading) setOneLinkUrlToCopy('');
  }, [shortenedConfigs.magaly.isLoading, shortenedConfigs.onelink.isLoading]);
  return {
    magaly: {
      shortenLink: shortenedConfigs.magaly,
      urlToCopy: magalyUrlToCopy
    },
    oneLink: {
      shortenLink: shortenedConfigs.onelink,
      urlToCopy: oneLinkUrlToCopy
    }
  };
};
export default useProductShortenLink;